import React, { useState, useEffect } from 'react'
import {Form, Button, DropdownButton, Dropdown, ProgressBar} from "react-bootstrap";
import axios from 'axios';
import SettingsHeader from './console/SettingsHeader';

function OnlineDrones(){
    const [onlineImei, setOnlineImei] = useState([]);

    useEffect(() => {
        console.log("OnlineDrones mount");
        getOnlineDroneInfo();
    }, []);

    useEffect(() => {
        return () => {
            console.log("OnlineDrones unmount");
        };
    }, []);

    function getOnlineDroneInfo(){
        axios.get('api/admin/getAllOnlineModem')
        .then(response => {
            console.log(response)
            setOnlineImei(response.data.imeis);
        });
    }

    return(
        <>
            <SettingsHeader />
            <div className='blocks'>
                <div>Online: {onlineImei?.length}</div>
                {/*onlineImei.map(imei => <div>{imei.imei} {imei.email} {imei.ip}</div>)*/}
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>IMEI</th>
                            <th>Email</th>
                            <th>IP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {onlineImei.map(imei =>
                        <tr key={imei.imei}>
                            <td>{imei.imei}</td>
                            <td>{imei.email}</td>
                            <td>{imei.ip}</td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
}
    

export default OnlineDrones;
